import colors from 'assets/theme/base/colors';

const link = {
    defaultProps: {
        color: colors.common.white,
    },
    styleOverrides: {
        root: {
            cursor: 'pointer',
            textDecorationColor: colors.common.white,
        },
    },
};

export default link;
